module.exports = __webpack_public_path__ + "img/pub_4.fc6ca568.png";